import React from "react";
import { Space, Avatar, Typography, Tag, Tooltip } from "antd";

import CustomLink from "@/components/ui/CustomLink";
import { getFullName, getName } from "@/utils";
import dayjs from "dayjs";

import { useEmployees } from "@/context/EmployeesContext";
import UserIcon from "@/icons/UserIcon";

const { Text } = Typography;

const EmployeeProfile = ({
  avatar,
  avatarSize = 30,
  align = "center",
  firstname,
  lastname,
  patronymic,
  position,
  dismissaldate,
  href,
  bold = false,
  noAvatar = false,
  fullName = true,
  showDismiss = false,
  tooltip = false,
  color,
  showPosition = false,
  uuid,
  employeesData = null,
  removed_from_unit = false,
  deleted = false,
}) => {
  // Используем переданные данные или контекст
  let employees;
  try {
    const context = useEmployees();
    employees = employeesData || context.employees;
  } catch (error) {
    // Если контекст недоступен, используем переданные данные
    employees = employeesData || [];
  }

  const fio = fullName
    ? getFullName(lastname, firstname, patronymic)
    : getName(lastname, firstname, patronymic);

  const authorName = `${lastname?.[0] || ""}${firstname?.[0] || ""}`;

  const is_dismissed =
    dismissaldate && !dayjs(dismissaldate).isAfter(dayjs(), "day");

  const status = employees.find((emp) => emp.employee_uuid === uuid)?.status;

  return (
    <Space className="custom-space" style={{ maxWidth: "100%" }} align={align}>
      {!noAvatar && (
        <Tooltip
          title={
            status === "online"
              ? "В сети"
              : status === "inactive"
                ? "Неактивен более 2 минут"
                : status === "offline"
                  ? "Не в сети"
                  : ""
          }
          placement="bottomLeft"
        >
          <div style={{ position: "relative" }}>
            <Avatar
              src={status ? avatar : null}
              size={avatarSize}
              style={{
                color: status ? "#E66A25" : "#777777",
                background: status ? "#FFEADE" : "#E9E9E9",
                fontWeight: 500,
                border: "none",
                textTransform: "uppercase",
              }}
            >
              {status ? authorName : <UserIcon />}
            </Avatar>
            {(status === "online" || status === "inactive") && (
              <div
                style={{
                  position: "absolute",
                  bottom: "-1px",
                  right: "-1px",
                  width: avatarSize / 3,
                  height: avatarSize / 3,
                  border: "1px solid #fff",
                  borderRadius: "50%",
                  backgroundColor: status === "online" ? "#2DAA55" : "#BBBBBB",
                }}
              />
            )}
          </div>
        </Tooltip>
      )}

      <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
        {!!href ? (
          <CustomLink to={href} style={{ fontWeight: bold ? 500 : 400 }}>
            {fio}
          </CustomLink>
        ) : tooltip ? (
          <Tooltip title={fio} placement="bottomLeft">
            <div
              style={{
                fontWeight: bold ? 500 : 400,
                color: color || "inherit",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {fio}
            </div>
          </Tooltip>
        ) : (
          <div
            style={{
              fontWeight: bold ? 500 : 400,
              color: color || "inherit",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {fio}
          </div>
        )}

        {position && showPosition && (
          <Text type="secondary">{position.name}</Text>
        )}
      </div>
      {showDismiss && is_dismissed && <Tag>Уволен</Tag>}
      {removed_from_unit ? (
        <Tag color="red">Исключен</Tag>
      ) : deleted ? (
        <Tag color="red">Удален</Tag>
      ) : (
        <></>
      )}
    </Space>
  );
};

export default EmployeeProfile;
